/**
 * Moduł zamykania modala
 *
 * @export
 * @class ModalCloseModule
 */
export class ModalCloseModule {
  /**
   * Stan modułu
   *
   * @memberof ModalCloseModule
   */
  public state = {
    show: false,
    title: '',
    text: '',
    confirm: false,
    confirmText: '',
    cancelText: ''
  };

  public mutations = {
    /**
     * Ukrywa okienko z potwierdzeniem zamkięcia modala
     *
     * @param localState stan lokalny
     */
    hideConfirmDialog: (localState: any): void => {
      localState.show = false;
    },
    /**
     * Pokazuje okienko z potwierdzeniem zamknięcia modala
     *
     * @param localState stan lokalny
     */
    showConfirmDialog(
      localState: any,
      {
        title = 'Potwierdź zamknięcia formularza',
        text = 'Formularz zawiera niezapisane dane. Na pewno chcesz go zamknąć?',
        confirmText = 'Zamknij',
        cancelText = 'Zostań'
      } = {}
    ): void {
      localState.show = true;
      localState.title = title;
      localState.text = text;
      localState.confirmText = confirmText;
      localState.cancelText = cancelText;
    },
    /**
     * Potwierdza zamknięcie modala
     *
     * @param localState stan lokalny
     */
    confirm(localState: any): void {
      localState.confirm = true;
    },
    /**
     * Resetuje stan potwierdzenia
     *
     * @param localState stan lokalny
     */
    resetConfirmState(localState: any): void {
      localState.confirm = false;

      localState.title = 'Potwierdź zamknięcia formularza';
      localState.text = 'Formularz zawiera niezapisane dane. Na pewno chcesz go zamknąć?';
    }
  };

  public actions = {
    /**
     * Wyświetla potwierdzenie zamknięcia modala
     *
     * @param context context
     */
    showConfirmDialog(context: any, data: any): void {
      context.commit('showConfirmDialog', data);
    },
    /**
     * Ukrywa potwierdzenie zamknięcia modala
     *
     * @param context context
     */
    hideConfirmDialog(context: any): void {
      context.commit('hideConfirmDialog');
    },
    /**
     * Potwierdza zamknięcie modala
     *
     * @param context context
     */
    confirm(context: any): void {
      context.commit('confirm');
    },
    /**
     * Resetuje stan potwierdzenia
     *
     * @param context context
     */
    resetConfirmState(context: any): void {
      context.commit('resetConfirmState');
    }
  };
}

export default new ModalCloseModule();
